// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 792 ? "main" : chunkId) + "." + {"221":"1bc10135","792":"9329465a"}[chunkId] + ".css";
};